// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__no7Ro","error":"Textarea_error__1dV-N","readonly":"Textarea_readonly__LbYNB","disabled":"Textarea_disabled__1v-u4"};